import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import Spinner from "../../components/Spinner";

import {
  PaymentAccount,
  NextStepsContainer,
  CurvelogoContainer,
  StepContainer,
  StepNumber,
  AppStoreLinks,
  CurveAccountContainer
} from "./styles";

import boboLogo from "./images/bobo-logo.png";
import copyIcon from "./images/copy-icon.svg";
import chevronRight from "./images/chevron-right.svg";
import appStoreLogo from "./images/app-store.svg";
import gplayLogo from "./images/play-store.svg";
import curveLogo from "./images/curve_logo.png";
import payAnyWhereImage from "../tap2start/img/pay-anywhere-image.png";
import euFlag from "./images/eu-flag.png";
import ukFlag from "./images/uk-flag.png";
import orSeparator from "./images/or.svg";

const CurveAccount = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const provider = searchParams.get("provider");
  const hidePrepaid = searchParams.get("hidePrepaid") === "true";

  console.log({ provider });

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: `?provider=${provider || "pannovate"}`
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch, provider]);

  const appStoreLinks = (appStoreUrl, playStoreUrl) => {
    return (
      <AppStoreLinks>
        <img
          src={appStoreLogo}
          alt="app-store"
          onClick={() => window.open(appStoreUrl, "_blank")}
        />
        <img
          src={gplayLogo}
          alt="play-store"
          onClick={() => window.open(playStoreUrl, "_blank")}
        />
      </AppStoreLinks>
    );
  };

  if (isLoading) return <Spinner />;

  return (
    <CurveAccountContainer>
      {!hidePrepaid && (
        <PaymentAccount>
          <p className="title">Payment Account</p>
          {provider === "pannovate" && (
            <>
              <p className="subtitle">Prepaid</p>
              <div className="inner">
                <img className="logo" src={boboLogo} alt="bourgeois boheme" />
                <p>
                  Want to continue enjoying unrivaled payment experience? Upgrade
                  to Bourgeois Bohème wallet!
                </p>
                <p>Your wearable activation code</p>
                <div className="activation-code">
                  <span>{balanceAndPin?.activationCode || "N/A"}</span>
                  <img
                    src={copyIcon}
                    alt="copy"
                    onClick={() =>
                      navigator.clipboard.writeText(balanceAndPin?.activationCode)
                    }
                  />
                </div>
                <div
                  className="button"
                  onClick={() =>
                    window.open(`https://uefa.bobofin.com/`, "_blank")
                  }
                >
                  {"Join Bourgeois Bohème"}{" "}
                  <img src={chevronRight} alt="chevron right" />
                </div>
              </div>
              {appStoreLinks(
                "https://apps.apple.com/us/app/bourgeois-boheme/id1574430730",
                "https://play.google.com/store/apps/details?id=com.paymeswiss.bobofin"
              )}
            </>
          )}
        </PaymentAccount>
      )}
      <NextStepsContainer>
        <CurvelogoContainer>
          {provider !== "much_better" && !hidePrepaid && (
            <img className="separator" src={orSeparator} alt="or" />
          )}
          <p className="title">Link your card</p>
          <img className="curve-logo" src={curveLogo} alt="curve logo" />
          <div className="flags">
            <img src={euFlag} alt="eu flag" />{" "}
            <img src={ukFlag} alt="uk flag" />
          </div>
        </CurvelogoContainer>
        <StepContainer>
          <StepNumber>1</StepNumber>
          <h2>Create a Curve Account</h2>
          <p>
            Register your card details with Curve to receive a free compatible
            digital bank card.
          </p>
          <p>Download the Curve App:</p>
          {appStoreLinks(
            "https://apps.apple.com/gb/app/curve-supercharge-your-money/id1049397112",
            "https://play.google.com/store/apps/details?id=com.imaginecurve.curve.prd"
          )}
        </StepContainer>
        <StepContainer>
          <StepNumber>2</StepNumber>
          <h2>Link Your Curve Virtual Card Using the Manage-Mii App</h2>
          <p>
            Follow the instructions on the Manage-Mii app and use your new Curve
            Card details when prompted.
          </p>
          {appStoreLinks(
            "https://apps.apple.com/app/manage-mii/id6446908503",
            "https://play.google.com/store/apps/details?id=com.digiseq.managemii"
          )}
        </StepContainer>
        <StepContainer>
          <StepNumber>3</StepNumber>
          <h2>Pay Anywhere!</h2>
          <p>
            Tap your wearable at any card terminal where Mastercard Contactless
            is enabled.
          </p>
          <img
            className="pay-anywhere"
            src={payAnyWhereImage}
            alt="pay anywhere"
          />
        </StepContainer>
      </NextStepsContainer>
    </CurveAccountContainer>
  );
};

export default CurveAccount;
